import React, { useState } from 'react';
import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import { ButtonProps, Circle, Icon } from '@chakra-ui/react';
import { FiArrowRight } from 'react-icons/fi';
import { CONTROL_SURFACE_SHADOW } from '@/components/ui/shadows';

interface AuthPrimaryButtonProps extends ButtonProps {
	children: React.ReactNode;
	hideArrowWhenNarrow?: boolean;
	hideArrow?: boolean;
}

const AuthPrimaryButton: React.FC<AuthPrimaryButtonProps> = (props: AuthPrimaryButtonProps) => {
	const { h = '48px', children, hideArrowWhenNarrow = false, hideArrow = false, ...rest } = props;
	const [isHovered, setIsHovered] = useState(false);

	return (
		<PrimaryButton
			fontWeight="medium"
			h={h}
			bg="brand.solid"
			color="brand.onSolid"
			boxShadow={CONTROL_SURFACE_SHADOW}
			_hover={{
				bg: 'brand.solidHover',
				color: 'brand.onSolid',
			}}
			position="relative"
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			{...rest}
		>
			{children}
			{!hideArrow && (
				<Circle
					position="absolute"
					right="1"
					size="40px"
					bg={isHovered ? 'brand.onSolid/95' : 'brand.onSolid'}
					color={isHovered ? 'brand.solid/95' : 'brand.solid'}
					css={hideArrowWhenNarrow ? { '@media (max-width: 359px)': { display: 'none' } } : undefined}
				>
					<Icon
						as={FiArrowRight}
						boxSize={30}
						transform={isHovered ? 'rotate(-45deg)' : 'rotate(0deg)'}
						transition="transform 0.2s ease-in-out"
					/>
				</Circle>
			)}
		</PrimaryButton>
	);
};

export default AuthPrimaryButton;
